/**
 * @file components/biz/common/ajaxAction
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import _ from 'lodash';

import {createPayload, fetch} from '../../common/helper';
import {AjaxOption} from '../index';
import {message} from '../../../../utils/bizUtil';

export const ajaxAction = (
    listPage: any,
    config: AjaxOption,
    payload: any,
    actions?: any
) => {
    // action方法名
    const {apiAction, $payloadFields, $extraPayload} = config;
    const {confirmText, confirmTitle, confirmType, okText = '确认', cancelText, $toastMessage} = config;
    // 勾子函数
    const {$onRequest, $onResponse, $onError} = config;
    const sendRequest = () => {
        const requestPayload = createPayload(payload, $payloadFields, $extraPayload);
        if (_.isFunction($onRequest)) {
            $onRequest.call(listPage, requestPayload);
        }
        return fetch(apiAction, requestPayload, actions)
            .then((response: any) => {
                if ($toastMessage) {
                    // 成功信息显示3秒
                    message('success', $toastMessage);
                }
                if (_.isFunction($onResponse)) {
                    // zhangzhe 2019-09-27 这里不return，依旧刷新列表 不确定会不会影响老页面，需要观察下
                    $onResponse.call(listPage, response, requestPayload);
                }
                // 刷新表单
                return listPage.loadList ? listPage.loadList() : Promise.resolve();
            })
            .catch((error: any) => {
                if (_.isFunction($onError)) {
                    $onError.call(listPage, error, requestPayload);
                }
                if (error.global) {
                    message('error', error.global);
                }
                else {
                    message('error', '请求失败，请检查');
                }
            });
    };
    // TODO acud暂无
    // 存在确认弹框
    if (confirmText) {
        return new Promise((resolve, reject) => {
            listPage.confirm({
                type: confirmType || 'error',
                title: confirmTitle ? _.template(confirmTitle)(payload) : '确认?',
                content: _.template(confirmText)(payload),
                okText,
                cancelText,
                onOk: () => resolve(true),
                onCancel: () => reject()
            });
        })
            .then(sendRequest)
            .catch(() => {
                // TODO
            });
    }
    return sendRequest();
};
